module.exports = __webpack_public_path__ + "img/sassRigais.2f1fc974.jpg";